export default () => {
  const dd = document.querySelectorAll('.p-form__form dd');

  dd.forEach((e) => {
    const c = e.children;
    Array.from(c).forEach((el) => {
      const val = el.getAttribute('value');
      if (val === '') {
        const bro = e.previousElementSibling;
        e.style.display = 'none';
        bro.style.display = 'none';
      }
    });
  });
};
